import { Header } from 'emerald-ui';
import styled from 'styled-components';
import { gray8 } from 'emerald-ui/dist/globals/colors';

export const TrackingHeader = styled(Header)`
    font-size: 4.5rem;
    color: ${gray8};
`;
